module.exports = __webpack_public_path__ + "static/img/banner-empleos-home-768x1024.4a58dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleos-home-768x1024.jpg
// module id = Tx7g
// module chunks = 47